const t = "編集するにはEnterキーを押します", e = {
  pressEnterToEdit: t
};
export {
  e as default,
  t as pressEnterToEdit
};
